import { gql } from '@apollo/client'

export const GET_FAQS_AND_CATEGORIES_QUERY = gql`
  query getFaqsAndCategories(
    $faqs_filter: faqs_filter
    $faq_categories_filter: faq_categories_filter
    $faqs_translations_filter: faqs_translations_filter
    $faq_categories_translations_filter: faq_categories_translations_filter
  ) {
    faqs(filter: $faqs_filter) {
      question
      slug
      translations(filter: $faqs_translations_filter) {
        id
        question
      }
      categories {
        faq_categories_id {
          id
          name
          translations(filter: $faq_categories_translations_filter) {
            id
            name
          }
        }
      }
    }
    categories: faq_categories(filter: $faq_categories_filter) {
      id
      name
      slug
      translations(filter: $faq_categories_translations_filter) {
        id
        name
      }
    }
  }
`
